module.exports = __webpack_public_path__ + "static/media/20ECE18.c9b91222.jpg";